import type { ReactNode } from "react"

/**
 * document-editor.md's DE-preview shared `dt`/`dd` composite — one row of
 * the "Документ Підписано" card and the sign confirmation `AlertDialog`'s
 * info list, both `dl`-wrapped by the caller.
 */
export function DocumentDetailField({
  label,
  value,
}: {
  label: string
  value: ReactNode
}) {
  return (
    <div className="flex items-center justify-between gap-4 text-sm">
      <dt className="text-muted-foreground">{label}</dt>
      <dd className="font-medium">{value}</dd>
    </div>
  )
}
